import OapImmersiveBeforeAfter from './code/Scripts/components/OapImmersiveBeforeAfter.vue';

export default {
  components: {
    OapImmersiveBeforeAfter,
  },
};
